import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'

import { Localized } from '../../../localization/react'
import { useDiscoverReducer, useDiscoverState } from '../DiscoverContext'

const ResetAllFilters = () => {
  const {
    venueOfferingsActiveFilters,
    subSportsActiveFilters,
    venueActivityAvailabilityActiveFilters,
    venueAttributeActiveFilters,
    venueCourtAreasActiveFilters,
    venueCourtSurfaceActiveFilters,
    venueAmenitiesActiveFilters,
  } = useDiscoverState()
  const dispatch = useDiscoverReducer()

  const handleClick = () => {
    dispatch({ type: 'RESET_FILTERS' })
  }

  const isVisible = Boolean(
    venueOfferingsActiveFilters ||
    subSportsActiveFilters ||
    venueActivityAvailabilityActiveFilters ||
    venueAttributeActiveFilters ||
    venueCourtAreasActiveFilters ||
    venueCourtSurfaceActiveFilters ||
    venueAmenitiesActiveFilters,
  )

  return isVisible ? (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      component="button"
      onClick={handleClick}
      gap={1}
      sx={{
        border: '1px solid',
        backgroundColor: 'white',
        borderColor: 'mediumgray',
        boxSizing: 'border-box',
        borderRadius: 1,
        py: 2,
        px: 5,
        cursor: 'pointer',
        '&:hover': {
          borderColor: 'primary.main',
        },
      }}
    >
      <Text variant="small" sx={{ color: 'primary.main' }}>
        <Localized id="filters-reset-all" />
      </Text>
    </Stack>
  ) : null
}

export default ResetAllFilters
